import React from 'react';

export default function mapProps(mapper, BaseComponent) {
    return function (props) {
        return React.createElement(BaseComponent, mapper(props));
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-app/node_modules/@dhis2/d2-ui-core/build/es/component-helpers/mapProps.js
// module id = 886
// module chunks = 0